export default "__VITE_ASSET__BHId_xLI__"